import React from "react";
import HighChart from "./HighChart";
import { getGroupedData } from "../../utility/utility";
import Skeleton from "react-loading-skeleton";

interface Consent {
  uid: string;
  request_time: string; // ISO 8601 date string
}

interface ConsentsData {
  consents: { consents: Consent[] };
}

const ConsentsChart: React.FC<ConsentsData> = (props) => {
  const data = props?.consents?.consents
    ? getGroupedData(props?.consents?.consents, 25, 5, "minutes")
    : [];
  const categories = data?.map((entry) => entry.range).reverse() || [];
  const seriesData = data?.map((entry) => entry.count).reverse() || [];

  const consentsChartOptions = {
    chart: {
      type: "column",
      height: "220px",
      scrollablePlotArea: {
        minWidth: categories.length * 50,
        scrollPositionX: 0,
        scrollPositionY: 0,
      },
    },
    title: {
      text: "",
    },
    xAxis: {
      categories,
      lineColor: "rgba(164, 165, 181, 0.2)",
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineDashStyle: "Dash", // Set Y-axis grid lines to dashed
      gridLineColor: "rgba(164, 165, 181, 0.2)", // Optional: set grid line color
      gridLineWidth: 1,
    },
    credits: {
      enabled: false, // Disable credits
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "",
        data: seriesData, // Data points corresponding to categories
        color: "#4983ED",
      },
    ],
  };

  return props?.consents ? (
    <HighChart options={consentsChartOptions} />
  ) : (
    <Skeleton count={8} />
  );
};

export default ConsentsChart;
